import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { login } from '../../services/authService';

const Login: React.FC<{ onLoginSuccess: () => void }> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const history = useHistory();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const user = await login(username, password);
      localStorage.setItem('access_token', user.access_token); 
      localStorage.setItem ('current_user', JSON.stringify(user.person)); // Store the access token
      localStorage.setItem ('user_id', user.person.id); // Store the access token
      onLoginSuccess(); // Call the onLoginSuccess prop
      history.push('/dashboard');
    } catch (err) {
      setError('Invalid username or password');
    }
  };

    return (
        <div className="row justify-content-center">

            <div className="col-xl-10 col-lg-12 col-md-9">

                <div className="card o-hidden border-0 shadow-lg my-5">
                    <div className="card-body p-0">
                        <div className="row">
                            <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                            <div className="col-lg-6">
                                <div className="p-5">
                                    <div className="text-center">
                                        <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>
                                    </div>
                                    <form className="user" onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-user" 
                                            value={username} onChange={(e) => setUsername(e.target.value)} id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter User Name"/>
                                        </div>
                                        <div className="form-group">
                                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control form-control-user" id="exampleInputPassword" placeholder="Password"/>
                                        </div>
                                        <div className="form-group">
                                            <div className="custom-control custom-checkbox small">
                                                <input type="checkbox" className="custom-control-input" id="customCheck"/>
                                                <label className="custom-control-label" htmlFor="customCheck">Remember
                                                    Me</label>
                                            </div>
                                        </div>
                                        <button type='submit'  className="btn btn-primary btn-user btn-block">
                                            Login
                                        </button>
                                        <hr/>
                                        {error && <div className="alert alert-danger" role="alert">{error} </div>}
                                       
                                    </form>
                                    <hr/>
                                    <div className="text-center">
                                        <a className="small" href="forgot-password.html">Forgot Password?</a>
                                    </div>
                                    <div className="text-center">
                                        <a className="small" href="register.html">Create an Account!</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
};

export default Login;